import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import { ArrowLeft, Baby, HelpCircle } from 'lucide-react';
import { BabyDiagnosis } from '../components/diagnosis';

const BabyDiagnosisPage = ({ onBack, onComplete }) => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white pb-24">
      {/* Header */}
      <header className="bg-gradient-to-r from-pink-500 to-pink-600 text-white px-4 py-4 sticky top-0 z-30">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              onClick={onBack}
              className="text-white hover:bg-white/20"
              data-testid="baby-page-back-btn"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <div className="flex items-center gap-2">
              <Baby className="w-6 h-6" />
              <h1 className="text-lg font-semibold">
                {language === 'fr' ? 'Conseil Bébé' : 'Baby Advice'}
              </h1>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <span className="text-xs bg-white/20 px-2 py-1 rounded-full">
              0-36 mois
            </span>
          </div>
        </div>
      </header>
      
      {/* Info Banner */}
      <div className="bg-pink-100 border-b border-pink-200 px-4 py-3">
        <div className="max-w-4xl mx-auto flex items-center gap-3 text-pink-800">
          <HelpCircle className="w-5 h-5 flex-shrink-0" />
          <p className="text-sm">
            {language === 'fr' 
              ? 'Parcours dédié aux conseils dermo-cosmétiques pour les bébés et nourrissons.'
              : 'Dedicated path for dermo-cosmetic advice for babies and infants.'}
          </p>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="px-4 py-6">
        <BabyDiagnosis
          language={language}
          onComplete={onComplete}
          onCancel={onBack}
        />
      </div>
    </div>
  );
};

export default BabyDiagnosisPage;
